"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1544))
 * @lastsynced 2026-10-29T13:51:23.450Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const Filter = createSVGIcon(
  <path
    d="M3 5.214h13m0 0h5m-5 0v3.643m0-3.643V1M3 19.357h5.5m0 0H21m-12.5 0V23m0-3.643v-4.214"
    stroke="currentColor"
  />,
  "Filter",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      id: "zjw4qG",
      defaultMessage: "Filter",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: iconColor.primary,
    className: iconCls(),
  })
);
